export default function HeroSection() {
  return (
    <>
      <div className="hero-strip">
        <p>
          ✦ Connecting Hearts · Uniting Families · Velama Community Matrimonial
          ✦
        </p>
      </div>
      <section className="stats-bar">
        <div className="container">
          <div className="row g-3 text-center">
            <div className="col-6 col-md-3 stat-item">
              <div className="stat-num">1,240+</div>
              <div className="stat-label">Active Profiles</div>
            </div>
            <div className="col-6 col-md-3 stat-item stat-divider">
              <div className="stat-num">380+</div>
              <div className="stat-label">Successful Matches</div>
            </div>
            <div className="col-6 col-md-3 stat-item stat-divider">
              <div className="stat-num">18+</div>
              <div className="stat-label">Districts Covered</div>
            </div>
            <div className="col-6 col-md-3 stat-item stat-divider">
              <div className="stat-num">5 ★</div>
              <div className="stat-label">Community Trusted</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
